import * as React from 'react';

var NavigationConfigContext = React.createContext({});
var useSearchAPI = function () {
    var searchAPI = React.useContext(NavigationConfigContext).searchAPI;
    return searchAPI;
};
var useAuthAPI = function () {
    var authAPI = React.useContext(NavigationConfigContext).authAPI;
    return authAPI;
};
var useNavigation = function () {
    var navigation = React.useContext(NavigationConfigContext);
    return navigation;
};

export { NavigationConfigContext, useAuthAPI, useNavigation, useSearchAPI };
//# sourceMappingURL=NavigationConfigContext.esm.js.map
